import React from 'react';

import PostList from '../components/PostList';

export default class PostsController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {posts: props.posts};
  }

  componentWillMount() {
    const that = this;
    fetch('/api/posts', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((posts) => {
        that.setState({posts});
      });
    });
  }

  render() {
    if (!this.state.posts) {
      return <div>Loading...</div>;
    }

    return (<div className='post-list'>
      <PostList posts={this.state.posts} />
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/PostsController.js